<script>
  import ListVideo from '@components/List/Video'
  // import setWindowHistory from "@utils/window-history";
  // import { getDefaultBrand } from "@utils/zerone-get-default";
  // import { brandOptions } from "@utils/zerone-options";

  // const DEFAULT_SEARCH = {
  //   brand: '',
  //   month: '',
  //   query: ''
  // };

  export default {
    components: {
      ListVideo,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      },
      loadingFetchVideoList: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        // searchData: {
        //   brand: getDefaultBrand(this.$route.query.brand) || DEFAULT_SEARCH.brand,
        //   month: this.$route.query.month || DEFAULT_SEARCH.month,
        //   query: this.$route.query.query || DEFAULT_SEARCH.query
        // },
        // searchList: [
        //   {
        //     width: '20%',
        //     type: 'select',
        //     placeholder: '所有品牌',
        //     name: 'brand',
        //     options: brandOptions()
        //   },
        //   {
        //     width: '20%',
        //     type: 'month',
        //     placeholder: '不限時間',
        //     name: 'month',
        //   },
        //   {
        //     type: 'text',
        //     placeholder: '請輸入關鍵字',
        //     name: 'query',
        //   },
        // ],
        // videoList: this.list || [],
        // videoPagination: this.pagination || {},
        // loadingFetchVideoList: false
      }
    },
    computed: {
      // formattedList() {
      //   return this.videoList.map((item) => ({
      //     title: item.title,
      //     publish_up: item.publish_up,
      //     description: item.description,
      //     brands: item.brands[0],
      //     to: {
      //       name: 'video-item',
      //       params: {
      //         brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
      //         categoryAlias: item.category_alias,
      //         videoAlias: item.alias,
      //       },
      //     },
      //     videoId: this.formattedVideoId(item.extrafields.youtube_url.value)
      //   }))
      // },
    },
    created() {

    },
    methods: {
      // onSubmit(data) {
      //   setWindowHistory({
      //     query: {
      //       // ...this.$route.query,
      //       page: 1
      //     }
      //   });
      //   this.tryToFetchVideoList({

      //     storeParams: {
      //       // ...this.$route.params,
      //       page: 1
      //     }
      //   })
      // },
      onChangePagination(page) {
        this.$emit('changePagination', page)
        // this.tryToFetchVideoList({
        //   storeParams: {
        //     // ...this.$route.params,
        //     page
        //   }
        // })
      },
      // tryToFetchVideoList({ storeParams } = {}) {
      //   this.loadingFetchVideoList = true;
      //   const params = {
      //     // ...this.searchData,
      //     search_date: this.searchData.month,
      //     brand_alias: this.searchData.brand
      //       ? [this.searchData.brand]
      //       : '',
      //     search: this.searchData.query,
      //     page: this.$route.query.page,
      //     limit: 9,
      //     ...storeParams
      //   }
      //   this.$store.dispatch('article/fetchList', {
      //     contentAlias: 'video',
      //     params
      //   })
      //     .then((response) => {
      //       this.videoList = response.items;
      //       this.videoPagination = response.pagination;
      //     })
      //     .finally(() => {
      //       this.loadingFetchVideoList = false;
      //     })
      // },
      onClearSearch() {
        this.$emit('clearSearch')
        // Object.keys(this.searchData)
        //   .forEach(key => {
        //     this.searchData[key] = undefined
        //   });

        // setWindowHistory({
        //   query: {
        //     ...this.$route.query,
        //     ...this.searchData,
        //     page: 1
        //   }
        // });
        // this.tryToFetchVideoList({
        //   storeParams: {
        //     page: 1
        //   }
        // });
      },
      // formattedVideoId(id) {
      //   if(id.includes('=')){
      //     return id.split('=')[1]
      //   }else {
      //     return id.split('/')[id.split('/').length - 1]
      //   }
      // },
    }
  }
</script>
<template>
  <div>
    <ListVideo
      v-loading="loadingFetchVideoList"
      :list="list"
      type="grid"
    />
    <BasePagination2
      :pagination="pagination"
      @change="onChangePagination"
    />
  </div>
</template>
<style lang="scss">
  .SectionVideoItem {

  }
</style>
